// The `as const` is load-bearing: the typed key union is derived from this shape.
export const common = {
  ai: {
    useAiChat: {
      agentTitleWidget: '{{agentTitle}} Widget',
      anErrorOccurredWhileProcessing:
        'An error occurred while processing your request. Please try again.',
      someToolsWerenTLoaded:
        "Some tools weren't loaded because this agent exceeds the {{limit}}-tool limit — {{toolCount}} from {{serverNames}} are unavailable. Remove or reorder an MCP server on this agent.",
      thisAgentIsNoLonger: 'This agent is no longer available',
    },
  },
  analytics: {
    analytics: {
      about: {
        title: 'About usage analytics',
      },
      howYourWorkspaceIsUsing:
        'How your workspace is using Monks.Flow. Figures update roughly every couple of hours, so today is always partial.',
      usageAnalytics: 'Usage Analytics',
    },
    types: {
      last14Days: 'Last 14 days',
      last7Days: 'Last 7 days',
    },
  },
  analyticsDashboard: {
    analyticsDashboard: {
      activeUsers: 'Active Users',
      activeUsersSeries: 'Active users',
      agentSessions: 'Agent Sessions',
      averageOnDaysWithActivity: 'Average on days with activity',
      averagePerDay: 'Average per day',
      avgSessionDuration: 'Avg. Session Duration',
      failedAgentRuns: 'Failed Agent Runs',
      failedRuns: 'Failed runs',
      filesUploaded: 'Files uploaded',
      kbFilesUploaded: 'KB Files Uploaded',
      messagesExchanged: 'Messages Exchanged',
      minutes: 'Minutes',
      minutesValue: '{{value}} min',
      received: 'Received',
      sent: 'Sent',
      sentAndReceived: 'Sent and received',
      sessions: 'Sessions',
      totalOverThePeriod: 'Total over the period',
    },
    metricCard: {
      noActivityInThisPeriod: 'No activity in this period.',
      titleIsUnavailableRightNow: '{{title}} is unavailable right now.',
    },
    rangeToggle: {
      dateRange: 'Date range',
    },
  },
  appShell: {
    appSidebar: {
      myMcps: 'My MCPs',
      studioSettings: 'Studio settings',
    },
    sidebarUserPopover: {
      adminSettings: 'Admin settings',
      darkMode: 'Dark mode',
      emailCopied: 'Email copied!',
      getSupport: 'Get support',
      language: 'Language',
      languageMenuLabel: 'Interface language',
      legalInformation: 'Legal information',
      lightMode: 'Light mode',
      organizationSettings: 'Organization settings',
      signOut: 'Sign out',
    },
    sidebarWorkspacePopover: {
      changeWorkspace: 'Change workspace',
      noWorkspacesFound: 'No workspaces found',
      searchWorkspaces: 'Search workspaces',
    },
    sidebarWorkspaceTrigger: {
      workspaceLogo: 'Workspace logo',
    },
    useSidebarNavigation: {
      analytics: 'Analytics',
      home: 'Home',
      knowledge: 'Knowledge',
      projects: 'Projects',
      sessions: 'Sessions',
      support: 'Support',
      tools: 'Tools',
      trackers: 'Trackers',
    },
    useToolCategories: {
      untitledTool: 'Untitled Tool',
    },
  },
  api: {
    assets: {
      noDownloadUrl: 'No download URL received',
    },
    zipDownload: {
      failed: 'Zip download failed (status {{status}}).',
    },
  },
  artifact: {
    artifactDisplayName: {
      copyGenerationWidget: 'Copy Generation Widget',
      emailFlowWidget: 'Email Flow Widget',
      ideationWidget: 'Ideation Widget',
      imageGenerationWidget: 'Image Generation Widget',
      videoGenerationWidget: 'Video Generation Widget',
    },
    artifactKindPalette: {
      brief: 'Brief',
      contentTest: 'Content test',
      copy: 'Copy',
      creativeConcept: 'Creative concept',
      custom: 'Custom',
      email: 'Email',
      file: 'File',
      focusGroup: 'Focus group',
      image: 'Image',
      insight: 'Insight',
      interview: 'Interview',
      iqAnalysis: 'IQ analysis',
      htmlWidget: 'Widget',
      misc: 'Misc',
      opportunity: 'Opportunity',
      persona: 'Persona',
      strategy: 'Strategy',
      video: 'Video',
    },
    artifactVersionBadge: {
      version: 'v{{version}}',
    },
    existingArtifactsPicker: {
      loadMore: 'Load more',
      newestFirst: 'Newest first',
      searchArtifacts: 'Search artifacts',
    },
    pickerTable: {
      dateCreated: 'Date created',
      name: 'Name',
      noArtifactsInWorkspace: 'No artifacts in workspace',
      noMatches: 'No matches',
      selectAllArtifacts: 'Select all artifacts',
      selectArtifact: 'Select {{name}}',
      type: 'Type',
    },
    pickerToolbar: {
      allTypes: 'All types',
      filterByType: 'Filter by type',
      search: 'Search',
      type: 'Type',
    },
    workspaceArtifactSort: {
      nameAZ: 'Name (A–Z)',
      nameZA: 'Name (Z–A)',
      oldestFirst: 'Oldest first',
    },
  },
  artifacts: {
    useArtifactExport: {
      exportDownloadedSuccessfully: 'Export downloaded successfully',
      exportGenerationFailedPlease: 'Export generation failed. Please try again.',
      exportGenerationTimedOut: 'Export generation timed out. Please try again.',
      exportingYourFileThis: 'Exporting your file. This might take a few minutes',
      failedToDownloadExport: 'Failed to download export: {{message}}',
      unknownErrorOccurred: 'Unknown error occurred',
    },
  },
  brief: {
    mutations: {
      briefDeleted: 'Brief deleted',
      briefDuplicated: 'Brief duplicated',
      failedToDeleteBrief: 'Failed to delete brief',
      failedToDuplicateBrief: 'Failed to duplicate brief',
      titleCopy: '{{title}} Copy',
    },
    useExportBriefPdf: {
      failedToExportBriefAs: 'Failed to export brief as PDF',
    },
  },
  briefTemplate: {
    mutations: {
      failedToDeleteTemplate: 'Failed to delete template',
      failedToDuplicateTemplate: 'Failed to duplicate template',
      failedToPublishTemplate: 'Failed to publish template',
      failedToSaveTemplate: 'Failed to save template',
      nameCopy: '{{name}} Copy',
      templateDeleted: 'Template deleted',
      templateDuplicated: 'Template duplicated',
      templatePublished: 'Template published',
      templateSaved: 'Template saved',
    },
  },
  components: {
    aboutPageDialog: {
      gotIt: 'Got it',
    },
    actionFooter: {
      back: 'Back',
      cancel: 'Cancel',
      generate: 'Generate',
      next: 'Next',
      skip: 'Skip',
    },
    assetCard: {
      moreActions: 'More actions',
    },
    audienceInsightsModal: {
      dataSources: 'Data Sources',
      gwiData: 'GWI Data - {{section}}',
      researchAudience: 'Research Audience',
    },
    audienceInsightsTable: {
      audience: 'Audience %',
      audienceInsights: 'Audience insights',
      index: 'Index',
    },
    baseSwitcher: {
      openSelectionMenu: 'Open selection menu',
    },
    brandLogo: {
      alt: '{{brandName}} logo',
    },
    contactSupportEmail: {
      getSupportFromMonks: 'Get support from Monks',
    },
    copyButton: {
      copy: 'Copy',
      copied: 'Copied',
      failed: 'Could not copy',
    },
    contentLockCheckbox: {
      agentWontChangeContent: "The agent won't change this content in later prompts or QA fixes.",
      agentWontChangeImage: "The agent won't change this image in later prompts or QA fixes.",
      lockSetElsewhere: 'This lock can only be changed where it was set.',
      lockThisContent: 'Lock this content',
      lockThisImage: 'Lock this image',
    },
    contentToolbar: {
      searchPlaceholder: 'Search...',
    },
    dataSourcesTab: {
      cancel: 'Cancel',
      confirmDelete: 'Confirm delete',
      delete: 'Delete',
      deleteQuestion: 'Delete question',
      failedToDeleteQuestion: 'Failed to delete question',
      questionDeleted: 'Question deleted',
      youHavenTAskedGwi: "You haven't asked GWI any questions about this audience yet.",
    },
    deepLinkInterstitial: {
      askAMemberToInvite_analysis: 'Ask an analysis member to invite you, then try again.',
      askAMemberToInvite_briefTemplate:
        'Ask a brief template member to invite you, then try again.',
      askAMemberToInvite_contentTest: 'Ask a content test member to invite you, then try again.',
      askAMemberToInvite_focusGroup: 'Ask a focus group member to invite you, then try again.',
      askAMemberToInvite_guidelinesFolder:
        'Ask a guidelines folder member to invite you, then try again.',
      askAMemberToInvite_project: 'Ask a project member to invite you, then try again.',
      back: 'Back',
      cancel: 'Cancel',
      currentOrganization: 'current organization',
      goToHome: 'Go to home',
      notAvailable_analysis: 'Analysis not available',
      notAvailable_briefTemplate: 'Brief template not available',
      notAvailable_contentTest: 'Content test not available',
      notAvailable_focusGroup: 'Focus group not available',
      notAvailable_guidelinesFolder: 'Guidelines folder not available',
      notAvailable_project: 'Project not available',
      openingItSignsYouInto:
        'Opening it signs you into {{organizationName}}. Switching affects all open tabs.',
      stayIn: 'Stay in {{organizationName}}',
      switchOpen: 'Switch & open',
      thisEntityIsIn_analysis: 'This analysis is in <org>{{organizationName}}</org>',
      thisEntityIsIn_briefTemplate: 'This brief template is in <org>{{organizationName}}</org>',
      thisEntityIsIn_contentTest: 'This content test is in <org>{{organizationName}}</org>',
      thisEntityIsIn_focusGroup: 'This focus group is in <org>{{organizationName}}</org>',
      thisEntityIsIn_guidelinesFolder:
        'This guidelines folder is in <org>{{organizationName}}</org>',
      thisEntityIsIn_project: 'This project is in <org>{{organizationName}}</org>',
      weCouldnTLoadThe_analysis: "We couldn't load the selected analysis.",
      weCouldnTLoadThe_briefTemplate: "We couldn't load the selected brief template.",
      weCouldnTLoadThe_contentTest: "We couldn't load the selected content test.",
      weCouldnTLoadThe_focusGroup: "We couldn't load the selected focus group.",
      weCouldnTLoadThe_guidelinesFolder: "We couldn't load the selected guidelines folder.",
      weCouldnTLoadThe_project: "We couldn't load the selected project.",
      youDonTHaveAccess_analysis: "You don't have access to this analysis",
      youDonTHaveAccess_briefTemplate: "You don't have access to this brief template",
      youDonTHaveAccess_contentTest: "You don't have access to this content test",
      youDonTHaveAccess_focusGroup: "You don't have access to this focus group",
      youDonTHaveAccess_guidelinesFolder: "You don't have access to this guidelines folder",
      youDonTHaveAccess_project: "You don't have access to this project",
    },
    deleteConfirmationModal: {
      campaign: 'campaign',
      account: 'account',
      approvalChain: 'approval chain',
      brief: 'brief',
      cancel: 'Cancel',
      comment: 'comment',
      deleteResourceName: 'Delete {{resourceName}}?',
      deleteResourceType: 'Delete {{resourceType}}',
      deleting: 'Deleting...',
      file: 'file',
      folder: 'folder',
      project: 'project',
      section: 'section',
      taxonomy: 'taxonomy',
      template: 'template',
      tool: 'tool',
      yesIWantToDelete: 'Yes, I want to delete',
    },
    detailHeader: {
      goBack: 'Go back',
    },
    dropdownSelect: {
      clear: 'Clear',
      clearSearch: 'Clear search',
      clearSelection: 'Clear selection',
      noResults: 'No results',
      openMenu: 'Open menu',
      search: 'Search…',
      select: 'Select',
    },
    dropzone: {
      description: 'Max size is 100 MB',
      title: 'Drag and drop files here, or click to select files',
    },
    fileListItem: {
      removeFile: 'Remove file',
      uploadErrorDetails: 'Upload error details',
      uploading: 'Uploading',
    },
    globalAppHeader: {
      mainNavigation: 'Main navigation',
      supportEmailCopiedToClipboard: 'Support email copied to clipboard!',
    },
    imageEditDialog: {
      cancel: 'Cancel',
      failedToApplyImage: 'Failed to apply the image. Please try again.',
      replaceImage: 'Replace Image',
      save: 'Save',
    },
    imageSourcePicker: {
      dropAnImageHereOr: 'Drop an image here or click to browse',
      imageUrl: 'Image URL',
      knowledgeBase: 'Knowledge Base',
      loadingImages: 'Loading images...',
      noImagesFoundInThis: 'No images found in this knowledge base',
      preview: 'Preview',
      selected: 'Selected',
      supportsJpgPngWebP: 'Supports JPG, PNG, WebP',
      upload: 'Upload',
      uploaded: 'Uploaded',
      uploading: 'Uploading...',
    },
    modal: {
      close: 'Close',
      dialog: 'Dialog',
    },
    optimizedImage: {
      failedToLoadImage: 'Failed to load image',
    },
    ownerCell: {
      me: 'Me',
    },
    pageHeader: {
      aboutPage: 'About {{page}}',
      back: 'Back',
      backToToolHome: 'Back to {{tool}} home',
      rename: 'Rename',
    },
    paginationControls: {
      goToFirstPage: 'Go to first page',
      goToLastPage: 'Go to last page',
    },
    permissionTooltip: {
      noPermission: "You don't have permission to do this",
    },
    personaSelector: {
      noPersonasFound: 'No personas found',
      searchPersonas: 'Search personas',
      unknownSegment: 'Unknown Segment',
    },
    popupTextInput: {
      atLeastOneSelectionNeeded: 'At least one selection needed',
      done: 'Done',
      select: 'Select',
    },
    preResolvedAvatarCell: {
      userAvatar: 'User avatar',
    },
    removeElementButton: {
      confirmRemove: 'Confirm remove?',
      remove: 'Remove',
    },
    researchAudienceTab: {
      enterQuestions: 'Enter questions',
      noInsightsFoundForThis:
        'No insights found for this audience. Try rephrasing your question — a different topic, audience, or timeframe.',
      researchAudience: 'Research audience',
      somethingWentWrongAskingGwi: 'Something went wrong asking GWI. Please try again.',
      whatWouldYouLikeTo: 'What would you like to know?',
    },
    sectionCard: {
      comingSoon: 'Coming Soon',
    },
    sidePanel: {
      agent: 'Agent: {{agentName}}',
      error: 'Error: {{message}}',
      noWidgetDataAvailable: 'No widget data available',
      unknown: 'Unknown',
      unknownError: 'Unknown error',
      widgetComponentNotFound: 'Widget component not found',
      widgetRenderingError: 'Widget rendering error',
    },
    sidePanelContainer: {
      noWidgetFound: 'No widget found',
      oopsNoWidgetFound: 'Oops! No widget found',
      pleaseSelectADifferentAgent: 'Please select a different agent.',
    },
    sidePanelHeader: {
      close: 'Close',
      close2: 'close',
    },
    sidePanelWrapper: {
      close: 'close',
      closeSection: 'Close {{title}} section',
      code: 'Code',
      copy: 'copy',
      copyTitle: 'Copy {{title}}',
      download: 'download',
      downloadTitle: 'Download {{title}}',
      preview: 'Preview',
      switchTo: 'Switch to {{target}}',
      version: 'Version {{version}}',
    },
    stepTracker: {
      completed: 'Completed',
      stepsLabel: 'Steps',
    },
    successBanner: {
      dismissBanner: 'Dismiss banner',
    },
    tableFilterIcon: {
      filter: 'Filter {{label}}',
    },
    tablePaginationBar: {
      displayedRows: '{{from}}-{{to}} of {{total}}',
      rowsPerPage: 'Rows per page',
    },
    tableSortCell: {
      sortedAscending: 'sorted ascending',
      sortedDescending: 'sorted descending',
    },
    toggleViewSwitch: {
      emailView: 'Email View',
      html: 'HTML',
      switchTo: 'Switch to {{target}}',
    },
    customAgentChip: {
      label: 'Custom',
      org: 'Custom agent · shared with everyone in the organization',
      user: 'Custom agent · only you can use it',
      workspace: 'Custom agent · shared with some workspaces',
    },
    toolCard: {
      ariaLabel: '{{title}} tool',
      comingSoon: 'Coming Soon',
      untitledAgent: 'Untitled Agent',
    },
    toolCardV4: {
      untitledAgent: 'Untitled Agent',
    },
    toolSubmenu: {
      categoryOverview: '{{categoryLabel}} Overview',
      notAvailable: 'Not available',
      overview: 'Overview',
    },
    toolSwitcher: {
      overview: 'Overview',
    },
    unsavedChangesModal: {
      cancel: 'Cancel',
      looksLikeYouMadeSome: 'Looks like you made some changes. Leave without saving?',
      unsavedChanges: 'Unsaved changes',
      yesIWantToLeave: 'Yes, I want to leave',
    },
    userAvatar: {
      alt: 'User avatar',
    },
    userMenu: {
      adminSettings: 'Admin settings',
      legalInformation: 'Legal information',
      signOut: 'Sign out',
      userMenu: 'User Menu',
      userMenu2: 'User menu',
    },
    videoPlayer: {
      mute: 'Mute',
      muteVideo: 'Mute video',
      pause: 'Pause',
      pauseVideo: 'Pause video',
      play: 'Play',
      playVideo: 'Play video',
      unmuteVideo: 'Unmute video',
      yourBrowserDoesNotSupport: 'Your browser does not support the video tag.',
    },
    wizardLayout: {
      goBack: 'Go back',
    },
    workspaceMenu: {
      adminSettings: 'Admin settings',
      backToHome: 'Back to Home',
      changeWorkspace: 'Change workspace',
      organization: 'Organization',
      organizationLogoAlt: '{{name}} logo',
      search: 'Search',
      selectWorkspace: 'Select workspace',
      signOut: 'Sign Out',
      switchOrganization: 'Switch organization',
      workspaceMenu: 'Workspace menu',
      workspaceSelector: 'Workspace selector',
      workspaces: 'Workspaces',
    },
    workspacesField: {
      countSelected: '{{count}} of {{total}} selected',
      noWorkspacesFound: 'No workspaces found.',
      selectWorkspaces: 'Select workspaces',
      workspaces: 'Workspaces',
    },
  },
  constants: {
    categoryGreetings: {
      buildSmarterShipFaster: 'Build smarter. Ship faster.',
      generateFreshIdeasCraft:
        'Generate fresh ideas, craft standout content, and turn insights into compelling campaigns, all while keeping your team in flow.',
      getHelpKeepMoving: 'Get help. Keep moving.',
      goLiveStayAhead: 'Go live. Stay ahead.',
      launchWorkSeamlesslyKeep:
        'Launch work seamlessly, keep everything running smoothly, and make quick optimizations as your campaign goes live.',
      makeSenseOfTheMessy:
        'Make sense of the messy. Turn raw thoughts into clear strategy. Generate insights, define priorities, and move forward with confidence.',
      neverGetStuckConnect:
        'Never get stuck. Connect instantly with support agents, access step-by-step guidance, and explore training videos whenever you need them.',
      scaleSmarterAmplifyResults: 'Scale smarter. Amplify results.',
      seeAheadShapeStrategy: 'See ahead. Shape strategy.',
      turnYourStrongestIdeasInto:
        'Turn your strongest ideas into repeatable growth. Optimize performance, automate what works, and keep momentum high across every market.',
    },
    fileUpload: {
      failedToUploadFilesPlease: 'Failed to upload files. Please try again.',
      fileFailedToProcess: '{{filename}} failed to process.',
      fileProcessedAndAdded: '{{filename}} processed and added.',
      fileSkippedDuplicate: '{{filename}} skipped (duplicate)',
      files: 'files',
      noFilesWereProcessed: 'No files were processed',
      sizeExceeded: '{{fileName}} exceeds {{maxSizeMb}}MB limit',
      unsupportedType: '{{fileName}} has an unsupported file type',
    },
    socialMediaPlatformsConstants: {
      discord: 'Social media data from Discord',
      facebook: 'Social media data from Facebook',
      instagram: 'Social media data from Instagram',
      linkedIn: 'Social media data from LinkedIn',
      other: 'Social media data from other platforms',
      pinterest: 'Social media data from Pinterest',
      reddit: 'Social media data from Reddit',
      snapchat: 'Social media data from Snapchat',
      telegram: 'Social media data from Telegram',
      threads: 'Audience segmentation data from Threads',
      tikTok: 'Social media data from TikTok',
      twitch: 'Social media data from Twitch',
      twitterX: 'Social media data from Twitter/X',
      whatsApp: 'Social media data from WhatsApp',
      youTube: 'Social media data from YouTube',
    },
  },
  hooks: {
    useDeepLinkResolution: {
      switchedToWorkspace: 'Switched to workspace {{workspaceName}}',
    },
    useOrganizationDisplayName: {
      thisOrganization: 'this organization',
    },
  },
  homePageDashboard: {
    iWantToTalkAboutSpark: 'I want to talk with {{persona}} about what they said: "{{spark}}"',
  },
  lib: {
    customAddButton: {
      add: 'Add',
      addOptional: 'Add (Optional)',
    },
    customCheckboxWidget: {
      false: 'False',
      true: 'True',
    },
    customCopyButton: {
      copy: 'Copy',
    },
    customMoveDownButton: {
      moveDown: 'Move Down',
    },
    customMoveUpButton: {
      moveUp: 'Move Up',
    },
    customRemoveButton: {
      remove: 'Remove',
    },
    customSubmitButton: {
      reset: 'Reset',
      send: 'Send',
    },
    customTextWidget: {
      enterA: 'Enter a {{label}}',
      value: 'value',
    },
    fileUpload: {
      fileTooLarge: 'The file is too large to upload.',
      noUploadUrl: 'No upload URL received',
      theFileUploadFailed: 'The file upload failed. Please try again.',
      theFileUploadFailedWithCode: 'The file upload failed ({{code}}). Please try again.',
      uploadLinkExpired: 'The upload link expired. Please try again.',
      uploadLinkInvalid: 'The upload link is no longer valid. Please try again.',
      uploadRejected: 'The upload was rejected. Please try again.',
      uploadUrlFailed: 'Failed to get file upload URL: {{message}}',
    },
  },
  loading: 'Loading...',
  nacbIntake: {
    useNacbIntakeMutation: {
      failedToSubmitForm: 'Failed to submit form',
      failedToSubmitIntake: 'Failed to submit intake form: {{message}}',
      theTriggerIntakeForm: 'The trigger intake form has been submitted',
    },
  },
  notFound: {
    oops: 'Oops',
    sorryAnUnexpectedErrorHas: 'Sorry, an unexpected error has occurred.',
  },
  projectFolder: {
    approvalBreakdownUtils: {
      completed: 'Completed',
      noApprovalChain: 'No approval chain',
      step: 'Step {{step}}',
    },
  },
  providers: {
    notificationProvider: {
      dismissNotification: 'Dismiss notification',
    },
  },
  rjsf: {
    addButton: 'Add',
    addItemButton: 'Add Item',
    ariaDateLabel: 'Select a date',
    arrayItemTitle: 'Item',
    clearButton: 'clear input',
    clearLabel: 'Clear',
    closeLabel: 'Close',
    copyButton: 'Copy',
    decrementAriaLabel: 'Decrease value by 1',
    emptyArray: 'No items yet. Use the button below to add some.',
    errorsLabel: 'Errors',
    filesInfo: '**{{p1}}** ({{p2}}, {{p3}} bytes)',
    incrementAriaLabel: 'Increase value by 1',
    invalidObjectField: 'Invalid "{{p1}}" object field configuration: _{{p2}}_.',
    keyLabel: '{{p1}} Key',
    missingItems: 'Missing items definition',
    moveDownButton: 'Move down',
    moveUpButton: 'Move up',
    newStringDefault: 'New Value',
    noLabel: 'No',
    nowLabel: 'Now',
    optionalObjectAdd: 'Add data for optional field',
    optionalObjectEmptyMsg: 'No data for optional field',
    optionalObjectRemove: 'Remove data for optional field',
    optionPrefix: 'Option {{p1}}',
    previewLabel: 'Preview',
    removeButton: 'Remove',
    titleOptionPrefix: '{{p1}} option {{p2}}',
    type: 'Type',
    unknownFieldType: 'Unknown field type {{p1}}',
    unsupportedField: 'Unsupported field schema.',
    unsupportedFieldWithId: 'Unsupported field schema for field `{{p1}}`.',
    unsupportedFieldWithIdAndReason: 'Unsupported field schema for field `{{p1}}`: _{{p2}}_.',
    unsupportedFieldWithReason: 'Unsupported field schema: _{{p1}}_.',
    value: 'Value',
    yesLabel: 'Yes',
  },
  routes: {
    weCouldnTFindThe: "We couldn't find the resource you are looking for",
  },
  sectionPicker: {
    copyEditDialog: {
      apply: 'Apply',
      cancel: 'Cancel',
      contentHtml: 'Content (HTML)',
      editContent: 'Edit content',
      empty: '(empty)',
      enterContent: 'Enter content...',
      lockedAsPartOfALargerSection:
        'Locked as part of a larger section — unlock that section instead.',
      lockedByTheTemplate: 'Locked by the template, so the agent never changes it.',
      selectedElement: 'Selected element',
      textContent: 'Text content',
      thisElementContainsFormattingHtml:
        'This element contains formatting. HTML tags will be preserved.',
    },
    sectionPickerIframe: {
      noTemplateContentToDisplay: 'No template content to display',
      templatePreview: 'Template Preview',
    },
    sectionPickerUtils: {
      alreadyExistsInThe: '"{{attributeName}}" already exists in the template.',
      closingTagNotFound: 'Closing tag not found for <{{tagName}}>.',
      couldNotDetermineElement: 'Could not determine element position.',
      couldNotFindMatching: 'Could not find matching closing tag.',
      couldNotLocateElement: 'Could not locate element in raw HTML.',
      elementsHaveNoEditable: '<{{tagName}}> elements have no editable content.',
      invalidAttributeName: '"{{attributeName}}" is not a valid HTML attribute name.',
      noElementMatches: 'No element matches "{{selector}}".',
    },
  },
  supportRequest: {
    supportRequestFields: {
      area: {
        home: 'Home',
        knowledge: 'Knowledge',
        other: 'Other',
        projects: 'Projects',
        sessions: 'Sessions',
        settings: 'Settings',
        tools: 'Tools',
      },
      areaOfPlatform: 'Area of Platform',
      askYourQuestion: 'Ask your question',
      attachmentFormatsHint: 'PNG, JPG or MP4, up to 25 MB each',
      attachments: 'Attachments',
      attachmentsSkippedHint:
        'Some files were skipped. Only PNG, JPG or MP4 files up to 25 MB each can be attached.',
      currentBehavior: 'Current Behavior',
      describeTheFeatureYouHaveInMind: 'Describe the feature you have in mind',
      descriptionOfFeature: 'Description of Feature',
      dragAScreenshotHereOrBrowse: 'Drag a screenshot here or browse',
      expectedBehavior: 'Expected Behavior',
      frequency: {
        daily: 'Daily',
        monthly: 'Monthly',
        rarely: 'Rarely',
        weekly: 'Weekly',
      },
      howCanWeHelp: 'How can we help?',
      howOftenDoesThisComeUp: 'How often does this come up?',
      isThisABlockerForYou: 'Is this a blocker for you?',
      no: 'No',
      screenshotsHelpUsReproduce: 'Screenshots help us reproduce the issue faster.',
      selectAFrequency: 'Select a frequency',
      selectAnArea: 'Select an area',
      type: {
        bug: 'Bug Report',
        feature: 'Feature Request',
        question: 'Question',
      },
      whatDidYouExpectToHappenInstead: 'What did you expect to happen instead?',
      whatIsHappeningRightNow: 'What is happening right now?',
      whatShouldItDo: 'What should it do, and what would it let you get done?',
      whatWouldYouLikeToLearnMoreAbout: 'What would you like to learn more about?',
      yes: 'Yes',
    },
    supportRequestSheet: {
      cancel: 'Cancel',
      done: 'Done',
      requestSubmitted: 'Request submitted',
      sendRequest: 'Send request',
      submitAnother: 'Submit another',
      support: 'Support',
      tellUsWhatYouNeed: "Tell us what you need and we'll route it to the right team.",
      weveLoggedYourRequest:
        "We've logged your request and routed it to the team that owns this area. You'll get an update by email.",
    },
  },
  ui: {
    schemaForm: {
      addEntry: 'Add {{label}}',
      entryKey: 'Key for {{key}}',
      invalidBoolean: 'Must be true or false',
      invalidNumber: 'Must be a number',
      invalidText: 'Must be text',
      itemLabel: '{{label}} {{index}}',
      noEntries: 'No entries yet',
      notAnOption: 'Not one of the available options',
      removeEntry: 'Remove {{label}}',
      required: 'This field is required',
      selectAnOption: 'Select an option',
      tooFewItems_one: 'Add at least {{count}} item',
      tooFewItems_other: 'Add at least {{count}} items',
      tooLarge: 'Must be {{max}} or less',
      tooLong_one: 'Use at most {{count}} character',
      tooLong_other: 'Use at most {{count}} characters',
      tooManyItems_one: 'Use at most {{count}} item',
      tooManyItems_other: 'Use at most {{count}} items',
      tooShort_one: 'Use at least {{count}} character',
      tooShort_other: 'Use at least {{count}} characters',
      tooSmall: 'Must be {{min}} or more',
      unsupportedField: '{{label}} uses a format this form cannot show',
    },
    approvalActionButton: {
      approve: 'Approve',
      approved: 'Approved',
    },
    featureSidebar: {
      featureNavigation: 'Feature navigation',
    },
    chatTranscriptPreview: {
      assistant: 'Assistant',
      noMessagesInThisConversation: 'No messages in this conversation.',
      you: 'You',
    },
    datePicker: {
      pickADate: 'Pick a date',
    },
    dateRangePicker: {
      flightToDate: 'Flight to date',
      last14Days: 'Last 14 days',
      last30Days: 'Last 30 days',
      last7Days: 'Last 7 days',
      lastMonth: 'Last month',
      thisMonth: 'This month',
    },
    emojiPicker: {
      addEmoji: 'Add emoji',
      gestures: 'Gestures',
      hearts: 'Hearts',
      objects: 'Objects',
      smileys: 'Smileys',
    },
    filterChipPopover: {
      all: 'All',
      clearFilter: 'Clear {{label}} filter',
      filterBy: 'Filter by {{label}}',
      filterByWithCount_one: 'Filter by {{label}}, {{count}} selected',
      filterByWithCount_other: 'Filter by {{label}}, {{count}} selected',
      noOptions: 'No options',
      search: 'Search {{label}}',
      searchOptions: 'Search {{label}} options',
    },
    projectPickerContent: {
      noProjectsFound: 'You have no projects in this workspace yet.',
      noProjectsFoundMatching: 'No projects match "{{searchQuery}}"',
    },
    projectPickerSearch: {
      search: 'Search...',
      searchProjects: 'Search projects',
      selectProjectsToSave: 'Select projects to save this artifact to',
    },
    saveToProjectPopover: {
      artifactIsNoLonger: 'Artifact is no longer in project {{projectName}}.',
      artifactRemovedFromProject: 'Artifact removed from project {{projectName}}.',
      artifactSavedToProject: 'Artifact saved to project {{projectName}}.',
      failedToRemoveArtifact:
        'Failed to remove artifact from project {{projectName}}. Please try again.',
      failedToPrepareItem: 'Failed to prepare this item for saving. Please try again.',
      failedToSaveTo: 'Failed to save to project. Please try again.',
      projectFallback: 'project',
      unableToSaveTo: "Unable to save to project: you don't have access to this artifact.",
      youDonTHavePermission: "You don't have permission to save to this project.",
    },
    searchInput: {
      search: 'Search',
      clearSearch: 'Clear search',
    },
    selectTextField: {
      noResults: 'No results.',
    },
    sortChipPopover: {
      byPrefix: '{{label}} by:',
      clear: 'Clear {{label}}',
      default: 'Default',
      sort: 'Sort',
      sortBy: 'Sort by',
    },
    startBriefPopover: {
      selectAProjectToCreate: 'Select a project to create brief',
      youDonTHavePermission: "You don't have permission to create a brief in this project.",
    },
    tagInput: {
      noResults: 'No results.',
      openList: 'Show options',
      removeTag: 'Remove {{label}}',
    },
    useSaveToProjectAction: {
      saveToProject: 'Save to project',
    },
  },
  utils: {
    countries: {
      afghanistan: 'Afghanistan',
      albania: 'Albania',
      algeria: 'Algeria',
      andorra: 'Andorra',
      angola: 'Angola',
      antiguaAndBarbuda: 'Antigua and Barbuda',
      argentina: 'Argentina',
      armenia: 'Armenia',
      australia: 'Australia',
      austria: 'Austria',
      azerbaijan: 'Azerbaijan',
      bahamas: 'Bahamas',
      bahrain: 'Bahrain',
      bangladesh: 'Bangladesh',
      barbados: 'Barbados',
      belarus: 'Belarus',
      belgium: 'Belgium',
      belize: 'Belize',
      benin: 'Benin',
      bhutan: 'Bhutan',
      bolivia: 'Bolivia',
      bosniaAndHerzegovina: 'Bosnia and Herzegovina',
      botswana: 'Botswana',
      brazil: 'Brazil',
      brunei: 'Brunei',
      bulgaria: 'Bulgaria',
      burkinaFaso: 'Burkina Faso',
      burundi: 'Burundi',
      caboVerde: 'Cabo Verde',
      cambodia: 'Cambodia',
      cameroon: 'Cameroon',
      canada: 'Canada',
      centralAfricanRepublic: 'Central African Republic',
      chad: 'Chad',
      chile: 'Chile',
      china: 'China',
      colombia: 'Colombia',
      comoros: 'Comoros',
      congo: 'Congo',
      costaRica: 'Costa Rica',
      croatia: 'Croatia',
      cuba: 'Cuba',
      cyprus: 'Cyprus',
      czechRepublic: 'Czech Republic',
      denmark: 'Denmark',
      djibouti: 'Djibouti',
      dominica: 'Dominica',
      dominicanRepublic: 'Dominican Republic',
      ecuador: 'Ecuador',
      egypt: 'Egypt',
      elSalvador: 'El Salvador',
      equatorialGuinea: 'Equatorial Guinea',
      eritrea: 'Eritrea',
      estonia: 'Estonia',
      eswatini: 'Eswatini',
      ethiopia: 'Ethiopia',
      fiji: 'Fiji',
      finland: 'Finland',
      france: 'France',
      gabon: 'Gabon',
      gambia: 'Gambia',
      georgia: 'Georgia',
      germany: 'Germany',
      ghana: 'Ghana',
      greece: 'Greece',
      grenada: 'Grenada',
      guatemala: 'Guatemala',
      guinea: 'Guinea',
      guineaBissau: 'Guinea-Bissau',
      guyana: 'Guyana',
      haiti: 'Haiti',
      honduras: 'Honduras',
      hungary: 'Hungary',
      iceland: 'Iceland',
      india: 'India',
      indonesia: 'Indonesia',
      iran: 'Iran',
      iraq: 'Iraq',
      ireland: 'Ireland',
      israel: 'Israel',
      italy: 'Italy',
      jamaica: 'Jamaica',
      japan: 'Japan',
      jordan: 'Jordan',
      kazakhstan: 'Kazakhstan',
      kenya: 'Kenya',
      kiribati: 'Kiribati',
      kosovo: 'Kosovo',
      kuwait: 'Kuwait',
      kyrgyzstan: 'Kyrgyzstan',
      laos: 'Laos',
      latvia: 'Latvia',
      lebanon: 'Lebanon',
      lesotho: 'Lesotho',
      liberia: 'Liberia',
      libya: 'Libya',
      liechtenstein: 'Liechtenstein',
      lithuania: 'Lithuania',
      luxembourg: 'Luxembourg',
      madagascar: 'Madagascar',
      malawi: 'Malawi',
      malaysia: 'Malaysia',
      maldives: 'Maldives',
      mali: 'Mali',
      malta: 'Malta',
      marshallIslands: 'Marshall Islands',
      mauritania: 'Mauritania',
      mauritius: 'Mauritius',
      mexico: 'Mexico',
      micronesia: 'Micronesia',
      moldova: 'Moldova',
      monaco: 'Monaco',
      mongolia: 'Mongolia',
      montenegro: 'Montenegro',
      morocco: 'Morocco',
      mozambique: 'Mozambique',
      myanmar: 'Myanmar',
      namibia: 'Namibia',
      nauru: 'Nauru',
      nepal: 'Nepal',
      netherlands: 'Netherlands',
      newZealand: 'New Zealand',
      nicaragua: 'Nicaragua',
      niger: 'Niger',
      nigeria: 'Nigeria',
      northKorea: 'North Korea',
      northMacedonia: 'North Macedonia',
      norway: 'Norway',
      oman: 'Oman',
      pakistan: 'Pakistan',
      palau: 'Palau',
      palestine: 'Palestine',
      panama: 'Panama',
      papuaNewGuinea: 'Papua New Guinea',
      paraguay: 'Paraguay',
      peru: 'Peru',
      philippines: 'Philippines',
      poland: 'Poland',
      portugal: 'Portugal',
      qatar: 'Qatar',
      romania: 'Romania',
      russia: 'Russia',
      rwanda: 'Rwanda',
      saintKittsAndNevis: 'Saint Kitts and Nevis',
      saintLucia: 'Saint Lucia',
      saintVincentAndTheGrenadines: 'Saint Vincent and the Grenadines',
      samoa: 'Samoa',
      sanMarino: 'San Marino',
      saoTomeAndPrincipe: 'Sao Tome and Principe',
      saudiArabia: 'Saudi Arabia',
      senegal: 'Senegal',
      serbia: 'Serbia',
      seychelles: 'Seychelles',
      sierraLeone: 'Sierra Leone',
      singapore: 'Singapore',
      slovakia: 'Slovakia',
      slovenia: 'Slovenia',
      solomonIslands: 'Solomon Islands',
      somalia: 'Somalia',
      southAfrica: 'South Africa',
      southKorea: 'South Korea',
      southSudan: 'South Sudan',
      spain: 'Spain',
      sriLanka: 'Sri Lanka',
      sudan: 'Sudan',
      suriname: 'Suriname',
      sweden: 'Sweden',
      switzerland: 'Switzerland',
      syria: 'Syria',
      taiwan: 'Taiwan',
      tajikistan: 'Tajikistan',
      tanzania: 'Tanzania',
      thailand: 'Thailand',
      timorLeste: 'Timor-Leste',
      togo: 'Togo',
      tonga: 'Tonga',
      trinidadAndTobago: 'Trinidad and Tobago',
      tunisia: 'Tunisia',
      turkey: 'Turkey',
      turkmenistan: 'Turkmenistan',
      tuvalu: 'Tuvalu',
      uganda: 'Uganda',
      ukraine: 'Ukraine',
      unitedArabEmirates: 'United Arab Emirates',
      unitedKingdom: 'United Kingdom',
      unitedStates: 'United States',
      uruguay: 'Uruguay',
      uzbekistan: 'Uzbekistan',
      vanuatu: 'Vanuatu',
      vaticanCity: 'Vatican City',
      venezuela: 'Venezuela',
      vietnam: 'Vietnam',
      yemen: 'Yemen',
      zambia: 'Zambia',
      zimbabwe: 'Zimbabwe',
    },
    dateUtils: {
      dAgo: '{{days}}d ago',
      daysAgo_one: '{{count}} day ago',
      daysAgo_other: '{{count}} days ago',
      hAgo: '{{hours}}h ago',
      hoursAgo_one: '{{count}} hour ago',
      hoursAgo_other: '{{count}} hours ago',
      mAgo: '{{minutes}}m ago',
      minutesAgo_one: '{{count}} minute ago',
      minutesAgo_other: '{{count}} minutes ago',
      moAgo: '{{months}}mo ago',
      now: 'Now',
      now2: 'now',
      wAgo: '{{weeks}}w ago',
      weeksAgo_one: '{{count}} week ago',
      weeksAgo_other: '{{count}} weeks ago',
      yAgo: '{{years}}y ago',
    },
    downloadFile: {
      fetchFailed: 'Failed fetch: {{status}} {{statusText}}',
    },
    format: {
      bytes: '{{size}} B',
      gigabytes: '{{size}} GB',
      kilobytes: '{{size}} KB',
      megabytes: '{{size}} MB',
    },
  },
} as const;
